module.exports = __webpack_public_path__ + "static/media/settings-icon.f568cdd4.svg";